/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Notes_Incomplete_HintInputs */



/**
* | output |
* | --- |
* | "Review the notes and mark as complete if done." |
*
* @param {Error_Nav_Notes_Incomplete_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_notes_incomplete_hint = /** @type {((inputs?: Error_Nav_Notes_Incomplete_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Notes_Incomplete_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Revoyez les notes et marquez-les comme terminees si fait.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überprüfen Sie die Notizen und markieren Sie sie als erledigt, falls Sie sie bearbeitet haben.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rivedi le note e, se fatto, contrassegna come completato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Просмотрите заметки и отметьте как выполненные, если они сделаны.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Revise las notas y marque como completa si está hecho.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请检查笔记，如果已完成，请标记为已完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メモを確認し、完了した場合は完了としてマークします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नोट्स की समीक्षा करें और पूरा हो जाने पर उसे पूर्ण के रूप में चिह्नित करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Revise as anotações e marque como concluídas, se já as tiver terminado.")
	return /** @type {LocalizedString} */ ("Review the notes and mark as complete if done.")
});